import { useState } from "react";
import "./ScheduleColumn.scss";
import ScheduleSlot from "../ScheduleSlot/ScheduleSlot";
import ModalComponent from "../../UI/ModalComponent/ModalComponent";
import SlotForm from "../../Slot/SlotForm/SlotForm";

const ScheduleColumn = ({
    element,
    warningSlots = null,
    slots,
    specialists,
    salons,
    currentSchedule,
    selectSlotsAction = null
}) => {
    const [modalOpenId, setModalOpenId] = useState(null)
    const [isSelected, setIsSelected] = useState(false);

    const hoverColumn = () => {
        setIsSelected(true);
    };

    const leaveColumn = () => {
        setIsSelected(false);
    };

    const closeModal = () => {
        setModalOpenId(null)
    }

    const openModal = (salonId) => {
        setModalOpenId(salonId)
    }

    const renderSlot = (salon, position, index) => {
        if (!position || !currentSchedule || !specialists?.length) {
            return <div data-row-id={`${salon.id}-${position.id}`} className="schedule-column__slots-cell-item" key={index} />;
        }

        const currentSlot = slots.find(
            item => item.position === position.id &&
                item.site_id === salon.id &&
                item.date_format === element.customDate
        );

        if (currentSlot) {
            const specialist = specialists.find(item => item.id === currentSlot.worker_id);
            if (specialist) {
                return (
                    <div data-row-id={`${salon.id}-${position.id}`} className="schedule-column__slots-cell-item" key={index}>
                        <ScheduleSlot
                            slot={currentSlot}
                            specialist={specialist}
                            selectSlotsAction={selectSlotsAction}
                        />
                    </div>
                );
            }
        }

        const isWarning = warningSlots?.[salon.id]?.includes(Number(position.id));
        const className = isWarning
            ? "schedule-column__slots-cell-item warning"
            : "schedule-column__slots-cell-item";

        return (
            <div data-row-id={`${salon.id}-${position.id}`} className={className} key={index}>
                <ModalComponent
                    isOpen={modalOpenId === `${salon.id}-${position?.id}-${element?.date}`}
                    isSlotsForm={true}
                    button={<div className="add-slot__button" onClick={() => openModal(`${salon.id}-${position?.id}-${element?.date}`)}></div>}>
                    <SlotForm closeModal={closeModal} salon={salon} position={position} date={element.customDate} listId={currentSchedule} />
                </ModalComponent>
            </div>
        );
    };

    return (
        <div
            className={"schedule-column" + (isSelected ? " selected" : "")}
        >
            <div
                className="schedule-column__header"
                onMouseEnter={hoverColumn}
                onMouseLeave={leaveColumn}
            >
                <span>{element.weekDay}</span>
                {element.dateStr}
            </div>
            <div className="schedule-column__slots">
                {salons.map((salon, index) => (
                    <div className="schedule-column__slots-cell" key={index}>
                        {salon.positions?.map((position, index) => renderSlot(salon, position, index))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ScheduleColumn;